<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">

          <el-form-item label="" class="fn-left">
            <el-input
              v-model="listQuery.title"
              placeholder="请输入名称"
            />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetCourseLists">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="success" @click="fnAddCourse()">添加</el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
    <div class="tuolele-main-box">
      <el-tabs
        v-model="listQuery.type"
        class="tll-tab-pane"
        @tab-click="handleClick"
      >
        <el-tab-pane label="托乐乐" name="1" />
        <el-tab-pane label="小班课" name="3" />
      </el-tabs>
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="课时名称" prop="title" align="center" />
        <el-table-column v-if="listQuery.type == 1" label="课时类型" prop="course_key_name" align="center" />
        <el-table-column v-if="listQuery.type == 3" label="科目" prop="subject_name" align="center" />
        <el-table-column label="优豆" prop="point_value" align="center" />
        <!-- <el-table-column label="适用校区" prop="shop_name" align="center" /> -->
        <el-table-column label="使用年级" prop="grade_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <!-- <el-button type="text" @click="fnEditFood(row)">编辑</el-button> -->
            <el-button type="text" style="color:red!important" @click="fnDeleteCourse(row.item_id,row.title)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="listQuery.p"
          prev-text="上一页"
          next-text="下一页"
          :total="total"
          :page-size="listQuery.limit"
          @current-change="fnGetCourseLists"
        />
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ total }}条</i>
          </span>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogAddCourseVisible" title="创建可兑换课时" width="80%">
      <add-exchange-course ref="addCourseDialog" :key="dialogAddCourseKey" @successCBK="fnAddSuccess()" />
    </el-dialog>
  </div>

</template>
<script>

// import Select from '@/components/Select'
import AddExchangeCourse from './AddExchangeCourse'
// import commondata from '@/utils/commondata'

export default {
  name: 'YcoinExchangeCourseManage',
  components: {
    // Select
    AddExchangeCourse
  },
  data() {
    return {
      selectList: [],
      lists: [],
      dialogAddCourseKey: 0,
      dialogAddCourseVisible: false,
      tableKey: 0,
      total: 0,
      listQuery: {
        p: 1,
        limit: 20,
        title: '',
        type: '1'
      }
    }
  },
  created() {
    this.fnGetCourseLists()
    // this.fnGetSelectList()
  },
  methods: {
    changeType: function() {

    },
    search: function() {

    },
    handleClick() {
      this.fnGetCourseLists()
    },
    fnGetCourseLists: function() {
      this.$http.getItemCreditsExchangeList(this.listQuery).then(res => {
        this.tableKey++
        this.lists = res.data
      })
    },
    fnDeleteCourse: function(id, title) {
      this.$confirm('确认删除“' + title + '”么？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.removeCreditsExchangeItem({ item_id: id }).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetCourseLists()
        })
      }).catch(() => {

      })
    },
    fnAddSuccess: function() {
      this.dialogAddCourseVisible = false
      this.fnGetCourseLists()
    },
    fnEditFood: function(food) {
      this.currentFood = food
      this.dialogAddCourseKey += 1

      this.dialogAddCourseVisible = true
    },
    fnAddCourse: function() {
      this.currentFood = ''
      this.dialogAddCourseKey += 1
      this.dialogAddCourseVisible = true
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
<style lang="scss" scope>
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px !important;
    border-top-left-radius: 8px !important;
  }
  .el-tabs--top .el-tabs__item.is-top:last-child{
    padding-right:20px!important
  }
</style>
